export default "__VITE_ASSET__DbjceeAK__";